/**************************************************
 * Nombre:       Tarjeta_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {COLORTEXTO} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Indicadores = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{py: 2}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', ml: -1}}>
                <Typography
                    sx={{
                        fontSize: sCell ? 32 : 48,
                        color: theme.palette.primary.main,
                        textAlign: 'center',
                        fontWeight: 700
                    }}>{`+${item.numero}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: sCell ? 16 : 18, color: COLORTEXTO, textAlign: 'center', fontWeight: 600, lineHeight: 1.1}}>
                    {item.nombre}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Indicadores    